import { ActionTree } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';
import { fetchPosts, fetchRegion } from '@/api';
import { StoreActions, StoreMutations } from '@/templates/DataNames';
// import { excludeNodes } from '@/heplers/excludeNodeByFqdn';
import { RegionData, RootState } from '../types';
import { TreeData } from '@/templates/Tree';

export const getCookieValue = (name: string, cookieHeader?: string): string => {
  // Если передан cookieHeader (с сервера), используем его
  if (cookieHeader) {
    const cookie = cookieHeader.split(';').find((c) => c.trim().startsWith(`${name}=`));
    if (cookie) {
      return cookie.split('=')[1];
    }
  }

  // На клиенте используем document.cookie
  if (typeof document !== 'undefined') {
    const cookie = document.cookie.split(';').find((c) => c.trim().startsWith(`${name}=`));
    if (cookie) {
      return cookie.split('=')[1];
    }
  }
};

export let fullContent: TreeData = {} as TreeData;

export const actions: ActionTree<RootState, RootState> = {
  [StoreActions.TREE]: async ({ commit, state }, { cookie }): Promise<void> => {
    const url = `getTree`;
    const isClient = typeof window !== 'undefined';

    const savedValue = isClient
      ? getCookieValue('with_by_link') || state.withByLink // client: cookie or Vuex (for SPA)
      : getCookieValue('with_by_link', cookie); // server: ONLY cookie from headers
    const withByLink = savedValue ? { with_by_link: String(savedValue) } : null;

    try {
      const response = await fetchPosts(url, withByLink);
      const tree = response.data;
      // const filteredTreeData = excludeNodes(tree);
      // commit(StoreMutations.TREE, filteredTreeData);

      commit(StoreMutations.TREE, tree);
    } catch (error) {
      console.error('Failed to fetch and process tree data');
    }
  },

  [StoreActions.COUNTRY_CODE]: async ({ commit }): Promise<void> => {
    const response: AxiosResponse<RegionData> = await fetchRegion();
    commit(StoreMutations.COUNTRY_CODE, response.data.country_code?.toLowerCase() || null);
  },

  [StoreActions.SEARCH]: async ({ commit }, data: string): Promise<void> => {
    const url = `searchDoc${data.trim()}`;
    const fromCookie = getCookieValue('with_by_link');
    const withByLink = fromCookie ? { with_by_link: fromCookie } : null;

    const response = await fetchPosts(url, withByLink);
    commit(StoreMutations.SEARCH, response.data);
  },

  [StoreActions.CONTENT]: async ({ state, commit }, { cookie, ...props }): Promise<void> => {
    const p = props
      ? '?' +
        Object.entries(props)
          .map((pair) => pair.join('='))
          .join('&')
      : '';
    const url = `getDoc${p}`;
    const isClient = typeof window !== 'undefined';

    const savedValue = isClient
      ? getCookieValue('with_by_link') || state.withByLink // client: cookie or Vuex (for SPA)
      : getCookieValue('with_by_link', cookie); // server: ONLY cookie from headers
    const withByLink = savedValue ? { with_by_link: String(savedValue) } : null;

    state.contentLoading = true;

    try {
      const response = await fetchPosts(url, withByLink);
      fullContent = response.data;
      // const filteredTreeData = excludeNodes([fullContent]);
      // commit(StoreMutations.CONTENT, filteredTreeData[0]);
      commit(StoreMutations.CONTENT, fullContent);
    } catch (error) {
      if ((error as AxiosError).response?.data?.status === 404) {
        state.notFound = true;
      }
    }
  },
};
